import { render } from "./BaseSelect.vue?vue&type=template&id=d015751c"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
script.render = render

export default script